// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__w8Bwh","dadosUsuario":"OptionSelect_dadosUsuario__zSHmA","focado":"OptionSelect_focado__vLt9G"};